export const appendQueryParam = (url, key, value) => {
  if (value !== '' && value !== null && value !== undefined) {
    return url + '&' + key + '=' + encodeURIComponent(value)
  }
  return url
}

export const hasAnyQueryValue = (values) => {
  return values.some((value) => value !== '' && value !== null && value !== undefined)
}
